<script setup lang="ts">
import toRem from "@/helpers/shared/toRem";
import { toRefs, type StyleValue } from "vue";

export type IconCircleVariant = "info" | "warning";
export type IconCircleSize = "xxs" | "xs" | "sm" | "md" | "lg" | "xl";

interface Props {
  icon?: string;
  variant?: IconCircleVariant;
  size?: IconCircleSize;
  customStyle?: string;
}

const props = withDefaults(defineProps<Props>(), {
  variant: "info",
  size: "md",
});

toRefs(props);

const VARIANT_MAP: Record<IconCircleVariant, string> = {
  info: "bg-darkOcean100",
  warning: "bg-red400 text-white",
};

const xx = (size: string) => {
  const styles: Partial<StyleValue> = {};
  styles.minHeight = size;
  styles.minWidth = size;
  styles.height = size;
  styles.width = size;

  return styles;
};

const SIZE_MAP: Record<IconCircleSize, string> = {
  xxs: toRem(1.75),
  xs: toRem(2),
  sm: toRem(2.5),
  md: toRem(3),
  lg: toRem(3.75),
  xl: toRem(6),
};

const ICON_SIZE_MAP: Record<IconCircleSize, string> = {
  xxs: "text-sm",
  xs: "text-sm",
  sm: "text-xl",
  md: "text-2xl",
  lg: "text-3xl",
  xl: "text-5xl",
};
</script>

<template>
  <div
    class="rounded-full flex justify-center items-center"
    :class="[customStyle ? customStyle : VARIANT_MAP[variant]]"
    :style="xx(SIZE_MAP[size])"
  >
    <slot>
      <i :class="[icon, ICON_SIZE_MAP[size]]"></i>
    </slot>
  </div>
</template>
